export enum ColumnName {
  NAME,
  BETSHOP,
  SHELL_STATUS,
}
